import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export enum AcceptDevStoreTermsResult {
  SUCCESS = "SUCCESS",
  ERROR__NO_TEAM_FOUND = "ERROR__NO_TEAM_FOUND",
  ERROR__NOT_A_DEV_STORE = "ERROR__NOT_A_DEV_STORE",
}

export const acceptDevStoreTerms = {
  name: "acceptDevStoreTerms" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.union([
    z.object({
      result: z.literal(AcceptDevStoreTermsResult.SUCCESS),
      /** False when the terms were already accepted before this call. */
      changed: z.boolean(),
    }),
    z.object({
      result: z.literal(AcceptDevStoreTermsResult.ERROR__NO_TEAM_FOUND),
    }),
    z.object({
      result: z.literal(AcceptDevStoreTermsResult.ERROR__NOT_A_DEV_STORE),
    }),
  ]),
};
export type AcceptDevStoreTermsOutput = z.infer<
  typeof acceptDevStoreTerms.output
>;
